// extracted by mini-css-extract-plugin
module.exports = {"headerButton":"HelpItem_headerButton__1qBIQ","down":"HelpItem_down__1rmWo","headerCopy":"HelpItem_headerCopy__3KFUr inline-multilang-support","body":"HelpItem_body__1iCv2"};